var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-dashboard-new-members-skeleton"},[_c('BCXSkeleton',{staticClass:"card",attrs:{"height":"284px","width":"260px","border-radius":"8px"}}),_c('BCXSkeleton',{staticClass:"message",attrs:{"height":"30px","border-radius":"15px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }